import React from 'react';
import clsx from 'clsx';
import './Tag.scss';

type Color = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';

interface Props {
  text?: string;
  color: Color;
}

const BASE_CLASS = 'ui-kit-tag';

const Tag: React.FC<Props> = ({ text, color = 'primary' }) => {
  const className = clsx(BASE_CLASS, `${BASE_CLASS}-${color}`);
  return <span className={className}>{text}</span>;
};

export default Tag;
